<template>
    <section class="section section-footer bg-primary-color-light">
        <div class="container">
            <div class="content">
                <div class="columns">
                    <div class="column is-full">
                        <hr />
                        <p><sup>1</sup> Dieser Rechner soll Ihnen einen ersten Überblick verschaffen, welche Kosten Sie bei uns für Ihren Autostrom zahlen und was Sie im Vergleich zum konventionellen Fahrzeug sparen können. Wir haben hier nur die CO2-Werte errechnet, die bei der Verbrennung entstehen. Weitere Belastungen wie z. B. Feinstaub werden ebenfalls emittiert, werden jedoch in dieser Berechnung nicht berücksichtigt.</p>
                        <p>Da die Anschaffung eines E-Autos meist teurer als ein Benziner oder Diesel-Fahrzeug ist, gibt es staatliche Förderungen und eine Befreiung von der Kfz-Steuer für 10 Jahre. Informationen hierzu entnehmen Sie bitte der Website des Bundesamts für Wirtschaft und Ausfuhrkontrolle <a href="https://www.bafa.de/DE/Energie/Energieeffizienz/Elektromobilitaet/elektromobilitaet_node.html" target="_blank">https://www.bafa.de/DE/Energie/Energieeffizienz/Elektromobilitaet/elektromobilitaet_node.html</a></p>
                        <p><sup>2</sup> Für Benzin wird ein durchschnittlicher Preis von 1,358 €/Liter und für Diesel ein durchschnittlicher Preis von 1,256 €/Liter angesetzt.</p>
                        <p><sup>3</sup> Bei den Stromkosten wurde der Tarif AB der Stadtwerke XY angesetzt. Es können durch Unterwegs-Tanken andere Preise anfallen.</p>
                        <p><sup>4</sup> Der durchschnittliche Gesamtpreis (Arbeitspreis + Grundpreis) wird anhand aller in Deutschland ermittelten Autostromtarife ermittelt. Quelle: ene't-Datenbank</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>